export const styles = {
  titleContainer: { marginTop: { xs: 3, lg: -7, md: -5 }, marginBottom: 3 },

  card: {
    mt: 2,
    mx: 2,
    mb: 6,
    p:2,
    width: { lg: "50%", md: "80%", xs: "100%" },
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    borderRadius: "20px",
    textAlign: "center",
  },

  elementCard: {
    mt: 1,
    py: 1,
    width: "100%",
    boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
    borderRadius: "20px",
    textAlign: "center",
  },

  flexCenter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  gridCenter: {
    display: "grid",
    alignItems: "center",
    justifyContent: "center",
  },

  backArrow: {
    display: "flex",
    justifyContent: "start",
    m: { lg: 2, md: 1, xs: 0 },
    fontSize: "230px",
    color: "#58738D",
  },

  deleteCross: {
    color: "#58738D",
  },

  button: {
    width: "200px",
    mt: 3,
    mb: 3,
  },

  formControl: {
    m: 4,
    width: "80%",
  },

  choiceFormControl: {
    ml: 2,
    mr: 1,
    width: "80%",
  },

  elementFormControl: {
    width: "90%",
    mb: 5,
  },

  field: {
    marginBottom: "10px",
    backgroundColor: "white",
    borderRadius: "20px",
    [`& fieldset`]: {
      borderRadius: "20px",
      border: "1px",
      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    },
  },

  errorText: {
    color: "#8B0000",
    fontWeight: "bold",
    fontSize: 12,
  },
};
